import { makeStyles } from "@mui/styles";
import { Theme, createTheme } from "@mui/material/styles";
import cyan from "@mui/material/colors/cyan";

export const useStyles = makeStyles<Theme>(() => ({
  textField: {
    fontSize: "16px !important",
    lineHeight: "1px",
    borderRadius: "20px",
    marginBottom: "15px",
  },
  picker: {
    border: "1px solid rgba(0,0,0,.2)",
    margin: "0 0 15px  !important",
    borderRadius: "5px",
    width: "100%",
    outline: "1px solid grey",

    "&.MuiInputBase-input": {
      border: "none",
    },
  },
  redStar: {
    color: "red",
  },
  required: {
    color: "red",
    float: "left",
  },
  label: {
    fontSize: "0.875rem", // Adjust the font size as needed
    transform: "translate(0, -1.5rem)", // Adjust the translation value as needed
    transition: "transform 0.2s",
    pointerEvents: "none",
  },
  textFieldFocused: {
    "& $label": {
      transform: "translate(0, -2.5rem)", // Adjust the translation value as needed
    },
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  scrollContainer: {
    overflowY: "auto",
    overflowX: "hidden",
  },
  // Add customGridContainer styles here
  customGridContainer: {  
    padding: '1px', // Padding inside the container 
  },
}));

export const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: cyan[500],
    },
  },
});
